import React, {Component, PropTypes} from 'react'
import Helmet from 'react-helmet'
import {Grid} from 'react-bootstrap'
import {Loader} from '../../core/redux/loading'

class AccountLayout extends Component {
    static propTypes = {
    }

    render() {
        const {children} = this.props

        return (
            <div>
                <Helmet title='Account' />
                <Grid>
                    <Loader
                        exclude={/Sent$/}>
                        {children}
                    </Loader>
                </Grid>
            </div>
        )
    }
}

export default AccountLayout


// WEBPACK FOOTER //
// ./lib/user/components/AccountLayout.js